import axios from 'axios';

class ARService {
    constructor() {
        this.state = {
            apiUrl: process.env.REACT_APP_API_URL,
        };
    }

    vistaReferralConfig(customerId) {
        return axios
            .get(this.state.apiUrl + 'appointment/vistaReferralConfig?customerId=' + customerId, { silent: true })
            .then((res) => {
                return res.data;
            })
            .catch((err) => {
                return err;
            });
    }

    getAllVRCFilter(customerId, search) {
        const url = this.state.apiUrl + 'appointment/getAllVRCFilter?customerId=' + customerId + '&search=' + search;
        if (
            url.includes(
                this.state.apiUrl + 'appointment/getAllVRCFilter?customerId=' + customerId + '&search=' + search,
            )
        ) {
            return axios
                .get(url, {
                    silent: true,
                })
                .then((res) => {
                    return res.data;
                })
                .catch((err) => {
                    return err;
                });
        } else {
            console.log(' URL ERROR....!');
        }
    }

    saveARConfig(data) {
        return axios
            .post(this.state.apiUrl + 'appointment/vistaReferralConfigSave', data, { silent: true })
            .then((res) => {
                return res.data;
            })
            .catch((err) => {
                return err;
            });
    }

    updateARConfig(data) {
        return axios
            .put(this.state.apiUrl + 'appointment/vistaReferralConfigUpdate', data, { silent: true })
            .then((res) => {
                return res.data;
            })
            .catch((err) => {
                return err;
            });
    }

    disableARConfig(data) {
        return axios
            .put(this.state.apiUrl + 'appointment/vistaReferralConfigDisable', data, { silent: true })
            .then((res) => {
                return res.data;
            })
            .catch((err) => {
                return err;
            });
    }
}
export default ARService;
